import { render } from "./TheCartOrderMap.vue?vue&type=template&id=64eb7ef0"
import script from "./TheCartOrderMap.vue?vue&type=script&lang=js"
export * from "./TheCartOrderMap.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__